<template>
  <div class="fans-follow-container">
    <div class="top">
      <div class="tabs">
        <div
          class="tab-item"
          :class="[type == 'follow' ? 'active' : '']"
          @click="onTabClick('follow')"
        >
          我的关注
        </div>
        <div
          class="tab-item"
          :class="[type == 'fans' ? 'active' : '']"
          @click="onTabClick('fans')"
        >
          粉丝管理
        </div>
      </div>
      <div class="search-box">
        <input
          v-model="query.keyword"
          placeholder="搜索关键词搜索"
          type="text"
          @keyup.enter="onSearch"
        />
        <img
          @click="onSearch"
          src="../../assets/images/icon-search-workbench.png"
        />
      </div>
    </div>
    <div class="status-box" v-if="type == 'follow'">
      <div class="status-item-box">
        <div
          v-for="(item, index) in group_list"
          :key="index"
          @click="query.group_id = item.id"
          :class="['status-item', { active: query.group_id == item.id }]"
        >
          {{ item.name }}({{ item.count || 0 }})
        </div>
      </div>
      <Poptip placement="bottom" trigger="hover">
        <template #content>
          <div class="btn-menu" @click="show_group=true">创建管理分组</div>
        </template>
        <div class="edit-btn">
          <img src="../../assets/images/icon-edit-group.png" />
        </div>
      </Poptip>
    </div>
    <div class="status-box" v-if="type == 'fans'">
      <div class="status-item-box">
        <div
          class="status-item"
          :class="[query.status == '-1' ? 'active' : '']"
          @click="query.status = '-1'"
        >
          全部粉丝({{ fans.count_all }})
        </div>
        <div
          class="status-item"
          :class="[query.status == '1' ? 'active' : '']"
          @click="query.status = '1'"
        >
          互相关注({{ fans.count_each }})
        </div>
        <div
          class="status-item"
          :class="[query.status == '2' ? 'active' : '']"
          @click="query.status = '2'"
        >
          粉丝({{ fans.count_single }})
        </div>
      </div>
    </div>
    <div class="follow-box" v-if="type == 'follow'">
      <div
        class="list-item"
        v-for="(item, index) in infiniteList"
        :key="`follow-${index}`"
      >
        <img
          @click="
            $router.push({ name: 'UserProfile', params: { code: item.code } })
          "
          :src="item.avatar | default_img"
        />
        <div class="nickname">{{ item.nickname || item.username }}</div>
        <div class="job-city">
          {{ item.job }} <span v-if="item.job && item.city">|</span>
          {{ item.city || "地球" }}
        </div>
        <div class="user-data">
          <div class="item">
            <div class="num">{{ item.create_num }}</div>
            <div class="item-title">笔记</div>
          </div>
          <div class="item">
            <div class="num">{{ item.design_num }}</div>
            <div class="item-title">款式创建</div>
          </div>
          <div class="item">
            <div class="num">{{ item.fans_num }}</div>
            <div class="item-title">粉丝</div>
          </div>
        </div>
        <div class="btn-follow" v-if="!item.need_follow">
          <div class="btn-text">已关注</div>
          <Poptip placement="bottom" trigger="hover">
            <template #content>
              <div class="btn-menu">
                <div class="menu-item" @click="onSetGroup(item)">
                  <div class="btn-text">设置分组</div>
                </div>
              </div>
              <div class="btn-menu">
                <div class="menu-item" @click="onFollowUser(item.id, index)">
                  <div class="btn-text">取消关注</div>
                  <img src="../../assets/images/icon-list-cancel.png" />
                </div>
              </div>
            </template>
            <div class="btn-icon"></div>
          </Poptip>
        </div>
        <div class="btn-unfollow" v-else @click="onFollowUser(item.id, index)">
          关注
        </div>
      </div>
    </div>
    <div class="fans-box" v-else>
      <div
        class="list-item"
        v-for="(item, index) in infiniteList"
        :key="`fans-${index}`"
      >
        <div class="item-container">
          <div class="info">
            <img :src="item.avatar | default_img" />
            <div class="user-info">
              <div class="nick-name">
                {{ item.nickname }}
                <span v-if="item.remark">({{ item.remark }})</span>
              </div>
              <div class="job-city">
                {{ item.job }} <span v-if="item.job && item.city">|</span>
                {{ item.city || "地球" }}
              </div>
              <div class="user-data">
                <div class="item">
                  笔记<span>{{ item.create_num }}</span>
                </div>
                <div class="item">
                  款式创建<span>{{ item.design_num }}</span>
                </div>
                <div class="item">
                  粉丝<span>{{ item.fans_num }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <div
              :class="[item.follow_each ? 'btn-follow-each' : 'btn-follow']"
              @click="onFollowUser(item.id, index)"
            >
              {{ item.follow_each ? "互相关注" : "回关" }}
            </div>
            <Button type="text" @click="onEditRemark(item.uf_id)">自定义备注</Button>
            <!-- <Poptip placement="bottom" trigger="hover"> -->
            <!-- <template #content>
                                <div class="btn-menu">
                                    <div class="menu-item">
                                        <div class="btn-text">举报</div>
                                        <img src="../../assets/images/icon-list-report.png"/>
                                    </div>
                                    <div class="menu-item">
                                        <div class="btn-text">拉黑</div>
                                        <img src="../../assets/images/icon-list-black.png"/>
                                    </div>
                                </div>
                            </template> -->
            <div class="btn-more" v-show="false"></div>
            <!-- </Poptip> -->
          </div>
        </div>
      </div>
    </div>
    <popup :show.sync="show_group">
      <div class="popup-container">
        <div class="pop-title">创建管理分组</div>
        <div class="create-box">
          <div
            class="create-btn"
            v-if="!is_creating"
            @click="is_creating = true"
          >
            <Icon type="md-add add-ico"></Icon>创建分组
          </div>
          <div class="create-input" v-else>
            <input
              type="text"
              placeholder="分组名称,最大长度16个字符"
              v-model="form.name"
            />
            <div class="btn-box">
              <div class="btn-cancel" @click="is_creating = false">取消</div>
              <div class="btn-confirm" @click="onCreateGroup">确认</div>
            </div>
          </div>
        </div>
        <div class="group-list">
          <div
            class="list-item"
            v-for="(item, index) in group_list.filter((item) => {
              return !['-1', '0'].includes(item.id);
            })"
            :key="index"
          >
            <div class="list-mode" v-if="!(is_editing && edit_mode_type === 'edit' && form.group_id === item.id)">
              <div class="left">
                <img v-if="!set_group_mode" src="../../assets/images/icon-list-menu.png" />
                <input v-else
                  type="radio"
                  :id="`group-${item.id}`"
                  v-model="form.group_id"
                  :value="item.id"
                  @click.stop
                />
                {{ item.name }}
              </div>
              <div class="right">
                <img
                  src="../../assets/images/icon-group-list-edit.png"
                  @click="onEditClick(item)"
                />
                <img src="../../assets/images/icon-group-list-trash.png"
                  @click="onDeleteClick(item)"
                />
              </div>
            </div>
            <div class="edit-mode" v-if="is_editing && edit_mode_type === 'edit' && form.group_id == item.id">
              <div class="edit-box">
                <input type="text" v-model="form.name" />
                <div class="btn-box">
                  <div class="btn-cancel" @click="onCancelEdit">
                    取消
                  </div>
                  <div class="btn-confirm" @click="onEditGroup">确认</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="set_group_mode" class="btn-box">
          <div class="btn-cancel" @click="onCancelSetGroup">取消</div>
          <div class="btn-confirm" @click="onConfirmSetGroup">确认</div>
        </div>
      </div>
    </popup>
    <Modal
      v-model="delete_confirm"
      title="删除分组"
      width="400"
      :closable="false"
      :mask-closable="false"
      @on-cancel="delete_confirm = false"
      @on-ok="onGroupDelete"
    >
      <div class="delete-content">
        确定要删除分组吗？分组内画板/用户不会被删除。
      </div>
    </Modal>
    <Modal
      v-model="edit_confirm"
      title="修改备注"
      width="400"
      :closable="false"
      :mask-closable="false"
      @on-cancel="edit_confirm = false"
      @on-ok="onEditConfirm"
    >
      <Input placeholder="请填写备注" v-model="remark_val" />
    </Modal>
  </div>
</template>
<script>
import {
  CreateGroup,
  DeleteGroup,
  EditGroup,
  FollowUser,
  GetGroupList,
  GetMyFansList,
  GetMyFollowList,
  SetUserGroup, editFansRemark
} from "@/api/social";
import infiniteMixin from "@/mixins/infinite";
import Popup from "../../components/Popup.vue";
export default {
  components: { Popup },
  data() {
    return {
      type: "follow",
      query: {
        status: "99",
        keyword: "",
        group_id: "-1",
      },
      fans: {
        count_all: 0,
        count_single: 0,
        count_each: 0,
      },
      group_list: [],
      fully_footer: false,
      loading_more: false,
      show_group: false,
      is_creating: false,
      form: {
        group_id: "",
        name: "",
        follow_id:''
      },
      edit_mode_type:'',
      delete_confirm: false,
      is_editing:false,
      set_group_mode:false,
      temp_group_id:'',
      edit_confirm:false,
      remark_val:'',
      uf_id:''
    };
  },
  mixins: [infiniteMixin],
  watch: {
    "query.status": {
      handler(newsVal, oldsVal) {
        if (newsVal === oldsVal) return;
        console.log("news", newsVal);
        this.getInfiniteList(true);
      },
      deep: true,
    },
    "query.group_id": {
      handler(newsVal, oldsVal) {
        if (newsVal === oldsVal) return;
        console.log("news", newsVal);
        this.getInfiniteList(true);
      },
      deep: true,
    },
    is_creating(news, olds) {
      if (!news) {
        this.group_name = "";
      }
    },
  },
  computed: {
    is_login() {
      return this.$store.state.is_login;
    },
    group_count_all() {
      return this.group_list.reduce((total, item) => {
        if (item.id != "-1") {
          total += item.count;
        }
        return total;
      }, 0);
    },
  },
  mounted() {
    const { type } = this.$route.params;
    console.log("type", type);
    if (!type) {
      console.log("type is null");
      history.back();
      return;
    }
    console.log("重载type", type);
    this.type = type;
    this.query.status = type == 'follow' ? '99' : '-1';
    this.infiniteList = [];
    this.getInfiniteList(true);
  },
  methods: {
    async onEditConfirm(){
      try{
        const param = {};
        param.remark = this.remark_val;
        param.uf_id = this.uf_id;
        const {code,msg} = await editFansRemark(param);
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg('操作成功~');
        this.edit_confirm = false;
        this.remark_val = '';
        this.uf_id = '';
        this.getInfiniteList(true);
      }catch(err){
        console.log('err-edit-remark',err);
      }
    },
    onEditRemark(uf_id){
      this.edit_confirm = true;
      this.uf_id = uf_id;
    },
    onCancelEdit(){
      this.is_editing = false;
      this.form = { group_id: this.temp_group_id || '', name: '' };
    },
    async onConfirmSetGroup(){
      const {form} = this;
      const {code,msg} = await SetUserGroup(form)
      this.$layer.msg(msg);
      if(code == 0){
        this.form = {group_id:'',name:''};
        this.show_group = false;
        this.set_group_mode = false;
        this.getInfiniteList(true);
      }
    },
    onCancelSetGroup(){
      this.set_group_mode = false;
      this.show_group = false;
      this.form = {group_id:'',name:''};
    },
    onSetGroup(item){
      console.log('item',item);
      this.show_group = true;
      this.set_group_mode = true;
      if(item.group_id) this.$set(this.form,'group_id',item.group_id);
      // this.form.follow_id = item.id;
      this.$set(this.form,'follow_id',item.id);
      console.log('form',this.form);
    },
    onDeleteClick(item){
      this.form.group_id = item.id;
      this.delete_confirm = true;
      this.edit_mode_type = 'delete';
    },
    async onGroupDelete(){
      const {form} = this;
      const {group_id} = form;
      const {code,msg} = await DeleteGroup({id:group_id});
      this.$layer.msg(msg);
      if(code == 0){
        this.delete_confirm = false;
        this.form = {group_id:'',name:''};
        this.onGetGroupList();
      }
    },
    async onEditGroup() {
      const { form } = this;
      const { group_id,name } = form;
      const { code, msg } = await EditGroup({id:group_id,name});
      this.$layer.msg(msg);
      if (code == 0) {
        this.form = { group_id: "", name: "" };
        this.is_editing = false;
        this.onGetGroupList();
      }
    },
    onEditClick(item) {
      this.temp_group_id = this.form.group_id;
      this.$set(this.form,'group_id',item.id);
      this.$set(this.form,'name',item.name);
      this.edit_mode_type = 'edit';
      this.is_editing = true;
    },
    async onCreateGroup() {
      const { form } = this;
      if (!form.name) {
        this.$layer.msg("请输入分组名称");
        return;
      }
      if (form.name.length > 16) {
        this.$layer.msg("分组名称不能超过16个字符");
        return;
      }
      const param = {};
      param.name = form.name;
      const { code, msg } = await CreateGroup(param);
      if (code == 0) {
        this.$layer.msg(msg);
        this.is_creating = false;
        this.$set(this.form,'name','');
        this.getInfiniteList(true);
      } else {
        this.$layer.msg(msg);
        return;
      }
    },
    handleScroll() {
      this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;

        if (offsetBottom <= 50) {
          this.fully_footer = true;

          if (this.loading_more || this.infiniteEnded) return;

          this.loading_more = true;
          this.getInfiniteList().finally(() => {
            this.loading_more = false;
          });
        } else {
          this.fully_footer = false;
        }
      });
    },
    async onGetGroupList() {
      try {
        const { data } = await GetGroupList();
        this.group_list = data;
      } catch (e) {
        console.log("eee-", e);
      }
    },
    onSearch() {
      this.getInfiniteList(true);
    },
    async onFollowUser(id, index) {
      try {
        const { type } = this;
        const need_follow = this.infiniteList[index].need_follow;
        const follow_each = this.infiniteList[index].follow_each;
        if (
          (type === "follow" && !need_follow) ||
          (type === "fans" && follow_each)
        ) {
          this.$DModal.confirm({
            content: "确认取消关注么?",
            onOK: async () => {
              await FollowUser({ follow_id: id });
              if (type === "follow") {
                this.$set(
                  this.infiniteList[index],
                  "need_follow",
                  !need_follow
                );
              } else {
                this.$set(
                  this.infiniteList[index],
                  "follow_each",
                  !follow_each
                );
              }
              this.$layer.msg("操作成功");
            },
          });
        } else {
          await FollowUser({ follow_id: id });
          if (type === "follow") {
            this.$set(this.infiniteList[index], "need_follow", !need_follow);
          } else {
            this.$set(this.infiniteList[index], "follow_each", !follow_each);
          }
          this.$layer.msg("操作成功");
        }
      } catch (e) {
        console.log("e", e);
        this.$layer.msg("操作失败");
      }
    },
    async getInfiniteData(pageindex, pageSize) {
      try {
        const { type } = this;
        const { keyword, status,group_id } = this.query;
        const param = { page: pageindex, limit: pageSize, keyword, status };
        const res = {};
        if (type === "follow") {
          this.onGetGroupList();
          param.group_id = group_id;
          const { data } = await GetMyFollowList(param);
          console.log("follow", data);
          res.data = data.list.length ? data.list : [];
          return res;
        } else {
          const { data } = await GetMyFansList(param);
          console.log("fans", data);
          const { count, count_each, count_single, list } = data;
          this.$set(this.fans, "count_all", count);
          this.$set(this.fans, "count_each", count_each);
          this.$set(this.fans, "count_single", count_single);
          res.data = list.length ? list : [];
          return res;
        }
      } catch (e) {
        console.log("e--infinite", e);
      }
    },
    onTabClick(type) {
      console.log('type===',type);
      if (!type) return;
      const param = {};
      param.type = type;
      console.log("param-----", param);
      this.$router.push({
        name: type == "follow" ? "MyFollow" : "MyFans",
        params: param,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./fansfollow.scss";
</style>
